import { IRequesterInfo } from '../../../../../base/models'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'

export class ProductClickReportApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/productClickStats',
      requesterInfo,
    })
  }

  // Mails boş bırakılırsa koddaki varsayılan adreslere gönderilir.
  public async sendMailProductClickReport(req: { StartDate: Date; EndDate: Date ,Company: Number, Mails?: string[] }): Promise<any> {
    return await this.postAsync<any>(req)
  }
}
